module.exports = __webpack_public_path__ + "images/snp2a99019322c1bd09ea61b28ccf518fd8.png";